import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import PropertyList from './pages/PropertyList';
import MapSearch from './pages/MapSearch';
import PropertyDetail from './pages/PropertyDetail';
import Favorites from './pages/Favorites';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import HostDashboard from './pages/HostDashboard';
import HostReservations from './pages/HostReservations';
import OwnerDashboard from './pages/OwnerDashboard';
import OwnerPropertyDetail from './pages/OwnerPropertyDetail';
import CreateProperty from './pages/CreateProperty';
import EditProperty from './pages/EditProperty';
import BookingDetail from './pages/BookingDetail';
import Messages from './pages/Messages';
import Profile from './pages/Profile';
import PrivateRoute from './components/PrivateRoute';

// Admin Pages
import AdminDashboard from './pages/AdminDashboard';
import AdminProperties from './pages/AdminProperties';
import AdminPropertyForm from './pages/AdminPropertyForm';
import AdminBookings from './pages/AdminBookings';
import AdminUsers from './pages/AdminUsers';
import AdminMessages from './pages/AdminMessages';
import AdminRevenue from './pages/AdminRevenue';
import AdminReviews from './pages/AdminReviews';
import AdminAPITokens from './pages/AdminAPITokens';

// Footer Pages - Support Section
import Help from './pages/Help';
import Safety from './pages/Safety';
import Cancellation from './pages/Cancellation';
import Covid from './pages/Covid';

// Footer Pages - Hosting Section
import Host from './pages/Host';
import HostResources from './pages/HostResources';
import HostCommunity from './pages/HostCommunity';
import ResponsibleHosting from './pages/ResponsibleHosting';

// Footer Pages - Company Section
import About from './pages/About';
import Careers from './pages/Careers';
import Press from './pages/Press';
import Investors from './pages/Investors';

// Footer Pages - Legal Section
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Sitemap from './pages/Sitemap';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/properties" element={<PropertyList />} />
              <Route path="/map" element={<MapSearch />} />
              <Route path="/properties/:id" element={<PropertyDetail />} />
              <Route path="/favorites" element={<Favorites />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              {/* Protected Routes */}
              <Route path="/dashboard" element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              } />
              <Route path="/host/dashboard" element={
                <PrivateRoute>
                  <HostDashboard />
                </PrivateRoute>
              } />
              <Route path="/host/reservations" element={
                <PrivateRoute>
                  <HostReservations />
                </PrivateRoute>
              } />
              <Route path="/host/properties/new" element={
                <PrivateRoute>
                  <CreateProperty />
                </PrivateRoute>
              } />

              {/* Owner Routes */}
              <Route path="/owner/dashboard" element={
                <PrivateRoute>
                  <OwnerDashboard />
                </PrivateRoute>
              } />
              <Route path="/owner/properties/new" element={
                <PrivateRoute>
                  <CreateProperty />
                </PrivateRoute>
              } />
              <Route path="/owner/properties/:id" element={
                <PrivateRoute>
                  <OwnerPropertyDetail />
                </PrivateRoute>
              } />
              <Route path="/host/properties/:id/edit" element={
                <PrivateRoute>
                  <EditProperty />
                </PrivateRoute>
              } />
              <Route path="/bookings/:id" element={
                <PrivateRoute>
                  <BookingDetail />
                </PrivateRoute>
              } />
              <Route path="/messages" element={
                <PrivateRoute>
                  <Messages />
                </PrivateRoute>
              } />
              <Route path="/profile" element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              } />

              {/* Admin Routes */}
              <Route path="/admin/dashboard" element={
                <PrivateRoute>
                  <AdminDashboard />
                </PrivateRoute>
              } />
              <Route path="/admin/properties" element={
                <PrivateRoute>
                  <AdminProperties />
                </PrivateRoute>
              } />
              <Route path="/admin/properties/new" element={
                <PrivateRoute>
                  <AdminPropertyForm />
                </PrivateRoute>
              } />
              <Route path="/admin/properties/:id/edit" element={
                <PrivateRoute>
                  <AdminPropertyForm />
                </PrivateRoute>
              } />
              <Route path="/admin/bookings" element={
                <PrivateRoute>
                  <AdminBookings />
                </PrivateRoute>
              } />
              <Route path="/admin/users" element={
                <PrivateRoute>
                  <AdminUsers />
                </PrivateRoute>
              } />
              <Route path="/admin/messages" element={
                <PrivateRoute>
                  <AdminMessages />
                </PrivateRoute>
              } />
              <Route path="/admin/revenue" element={
                <PrivateRoute>
                  <AdminRevenue />
                </PrivateRoute>
              } />
              <Route path="/admin/reviews" element={
                <PrivateRoute>
                  <AdminReviews />
                </PrivateRoute>
              } />
              <Route path="/admin/api-tokens" element={
                <PrivateRoute>
                  <AdminAPITokens />
                </PrivateRoute>
              } />

              {/* Footer Pages - Support Section */}
              <Route path="/help" element={<Help />} />
              <Route path="/safety" element={<Safety />} />
              <Route path="/cancellation" element={<Cancellation />} />
              <Route path="/covid" element={<Covid />} />

              {/* Footer Pages - Hosting Section */}
              <Route path="/host" element={<Host />} />
              <Route path="/host/resources" element={<HostResources />} />
              <Route path="/host/community" element={<HostCommunity />} />
              <Route path="/host/responsible" element={<ResponsibleHosting />} />

              {/* Footer Pages - Company Section */}
              <Route path="/about" element={<About />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/press" element={<Press />} />
              <Route path="/investors" element={<Investors />} />

              {/* Footer Pages - Legal Section */}
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/sitemap" element={<Sitemap />} />
            </Routes>
          </main>
          <Footer />
          <ToastContainer position="top-right" autoClose={3000} />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
